const LOAN_PROJECT_TYPE = {
  SOLAR: 'Solar',
  SOLAR_PLUS: 'Solar+',
  FLEX: 'Flex',
} as const;

const LOAN_PROJECT_SOLAR_TYPES = [
  LOAN_PROJECT_TYPE.SOLAR,
  LOAN_PROJECT_TYPE.SOLAR_PLUS,
] as const;

export const LOAN = {
  PROJECT_TYPE: LOAN_PROJECT_TYPE,
  PROJECT_SOLAR_TYPES: LOAN_PROJECT_SOLAR_TYPES,
};
